// extracted by mini-css-extract-plugin
export default {"preloaderContainer":"ForPreloader_preloaderContainer__TUDI2","preloaderGif":"ForPreloader_preloaderGif__+A-1u"};